import React, { Component } from 'react';

import { Loading, SERVER_ERROR } from 'commons';
import { PasswordStrength, passwordErrors } from 'commons';

import request from '../request';

class ResetPassword extends Component {
  state = {
    loading: true,
    email: '',
    password: '',
    passwordConfirm: '',
    token: this.props.match.params.token,
    reset_token: false,
    tokenExpiredOrInvalid: false,
    error: false,
    success: false,
    failure: false,
    passwordSyntaxErrors: [],
    passwordConfirmErrors: []
  };

  async componentDidMount() {
    try {
      const res = await request(`/reset-password/${this.state.token}`);

      this.setState({ loading: false });

      if (res.status === 400) {
        this.setState({ tokenExpiredOrInvalid: true });
        return;
      } else if (res.status !== 200) {
        this.setState({ loading: false, ...SERVER_ERROR });
        return;
      }

      const data = await res.json();
      this.setState({ email: data.email, reset_token: data.reset_password_token });
    } catch (error) {
      this.setState({ loading: false, ...SERVER_ERROR });
    }
  }

  handlePasswordChange = value => {
    this.setState({ password: value });
  };

  handleConfirmChange = async value => {
    await this.setState({ passwordConfirm: value });
    this.verifyPasswordConfirmation();
  };

  handleSubmit = async e => {
    e.preventDefault();

    if (this.state.passwordSyntaxErrors.length > 0 || this.state.passwordConfirmErrors.length > 0) {
      this.setState({ failure: true });
      return;
    }

    const { email, password, token, reset_token } = this.state;
    const formData = [
      `email=${encodeURIComponent(email)}`,
      `password=${encodeURIComponent(password)}`,
      `forgot_password_token=${encodeURIComponent(token)}`,
      `reset_password_token=${encodeURIComponent(reset_token)}`
    ];

    try {
      const res = await request('/reset-password', formData.join('&'));

      this.setState({ loading: false });

      if (res.status === 400) {
        this.setState({ tokenExpiredOrInvalid: true });
        return;
      } else if (res.status !== 200) {
        this.setState({ loading: false, ...SERVER_ERROR });
        return;
      }

      this.setState({ success: true });
    } catch (error) {
      this.setState({ loading: false, ...SERVER_ERROR });
    }
  };

  verifyPasswordSyntax = async password => {
    this.setState({ passwordSyntaxErrors: [] });
    if (password.length <= 0) return;

    try {
      const res = await request('/validate-password', `password=${encodeURIComponent(password)}`);

      if (res.status === 500) {
        this.setState({ passwordSyntaxErrors: ['Unexpected Error'] });
        return;
      }

      const data = await res.json();
      if (data.errors.length > 0) {
        this.setState({ passwordSyntaxErrors: passwordErrors(data.errors) });
      }
    } catch (error) {
      this.setState({ passwordSyntaxErrors: ['Unexpected Error'] });
    }

    this.verifyPasswordConfirmation();
  };

  verifyPasswordConfirmation = () => {
    const { password, passwordConfirm } = this.state;

    if (passwordConfirm.length <= 0 || password.length <= 0) return;

    if (password.trim() !== passwordConfirm.trim()) {
      this.setState({ passwordConfirmErrors: ['Passwords are not identical'] });
    } else {
      this.setState({ passwordConfirmErrors: [] });
    }
  };

  backToLogin() {
    const context = window.params ? window.params.continue : '/session/login';
    document.location.href = context;
  }

  renderMessage(message) {

    return (
      <div>
        <div className="margin-top-large">{message}</div>
        <div className="margin-top-medium">
          <button className="btnLink" onClick={this.backToLogin}>Back to login</button>
        </div>
      </div>
    );
  }

  renderForm() {
    const { password, passwordConfirm, passwordSyntaxErrors, passwordConfirmErrors } = this.state;

    if (this.state.loading) {
      return <Loading />;
    }

    if (this.state.success) {
      return this.renderMessage("Your password has been successfuly changed.");
    }

    if (this.state.tokenExpiredOrInvalid) {
      return this.renderMessage("The link to reset your password is invalid or has expired. Please try again.");
    }

    if (this.state.error.length > 0) {
      return this.renderMessage(this.state.error);
    }

    const errorMessage = this.state.failure ? <div className="message-error">Please verify your password</div> : null;

    return (
      <div>
        <p className="invite">Please type a new password</p>
        {errorMessage}
        <form className="form-fixed-width-small form-animated" onSubmit={this.handleSubmit}>
          <div className="margin-bottom-large text-align-left">
            <PasswordStrength
              placeholder="New password"
              value={password}
              errors={passwordSyntaxErrors}
              onChange={this.handlePasswordChange}
              onBlur={this.verifyPasswordSyntax}
              displayBar={password.length > 0}
            />
          </div>

          <div className="margin-bottom-large text-align-left">
            <PasswordStrength
              placeholder="Confirm"
              value={passwordConfirm}
              errors={passwordConfirmErrors}
              onChange={this.handleConfirmChange}
              displayBar={passwordConfirm.length > 0}
            />
          </div>

          <input className="btn" type="submit" value="RESET PASSWORD" />
        </form>
      </div>
    );
  }

  render() {
    return <div className="boxed-container">{this.renderForm()}</div>;
  }
}

export default ResetPassword;
